import createClient, {
	addApiErrorMessages,
	addAuthorizationErrorHandling,
	redirectToLoginMiddleware,
} from '@yoummday/ymmd-api-client';
import { Log } from '@yoummday/ymmd-logger';
import { getAppElement } from '@yoummday/ymmd-platform-core/comp/app-shell';
import { i18n } from './i18n';

export const API = createClient({
	baseUrl: `${import.meta.env.BASE_URL}/api`,
	credentials: 'include',
});

const authorizationErrorMiddleWare = addAuthorizationErrorHandling(() => {
	const app = getAppElement();
	app.view?.remove();
	app.showToast({
		variant: 'danger',
		str: i18n.txt?.error.ACCESS_DENIED_ERROR || '',
	});
	Log.error(new Error(`API returned authorization error`));
});

const errorMessageMiddleware = addApiErrorMessages(
	() => i18n.rawText!.error,
	(errorMsg, errorCode, path) => {
		const app = getAppElement();
		app.onShowMessage({
			detail: {
				variant: 'danger',
				str: errorMsg || `${i18n.rawText?.error.UNEXPECTED_ERROR} ${errorCode}`,
			},
		});

		if (!errorMsg) {
			Log.error(new Error(`API returned error "${errorCode}" calling ${path}`));
		}
	},
);

API.use(errorMessageMiddleware);
API.use(authorizationErrorMiddleWare);
API.use(redirectToLoginMiddleware);
